(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7329],{

/***/ 35962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconCar = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  width: 19,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M3.625 9.125H6.25M1 5.625l1.75.875 1.112-3.335c.23-.689.344-1.033.557-1.288a1.75 1.75 0 0 1 .702-.506c.309-.121.671-.121 1.397-.121h6.464c.726 0 1.088 0 1.397.121.273.108.514.282.702.506.213.255.328.6.557 1.288L16.75 6.5l1.75-.875m-5.25 3.5h2.625M5.2 6.5h9.1c1.47 0 2.205 0 2.767.286.494.252.895.653 1.147 1.147.286.562.286 1.297.286 2.767v2.363c0 .406 0 .61-.034.778a1.75 1.75 0 0 1-1.375 1.375c-.169.034-.372.034-.779.034h-.437a1.75 1.75 0 0 1-1.75-1.75.438.438 0 0 0-.438-.438H5.814a.438.438 0 0 0-.438.438 1.75 1.75 0 0 1-1.75 1.75h-.438c-.406 0-.61 0-.778-.034a1.75 1.75 0 0 1-1.375-1.375C1 13.672 1 13.47 1 13.063V10.7c0-1.47 0-2.205.286-2.767a2.625 2.625 0 0 1 1.147-1.147C2.995 6.5 3.73 6.5 5.2 6.5Z",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

/* harmony default export */ __webpack_exports__["Z"] = (SvgIconCar);

/***/ }),

/***/ 96669:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconGift = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M8 3.8V15M8 3.8H5.525c-.365 0-.714-.147-.972-.41a1.413 1.413 0 0 1-.403-.99c0-.371.145-.727.403-.99.258-.262.607-.41.972-.41C7.45 1 8 3.8 8 3.8Zm0 0h2.475c.365 0 .714-.147.972-.41s.403-.619.403-.99-.145-.727-.403-.99a1.363 1.363 0 0 0-.972-.41C8.55 1 8 3.8 8 3.8Zm5.6 3.5v5.46c0 .784 0 1.176-.153 1.476a1.4 1.4 0 0 1-.611.611c-.3.153-.692.153-1.476.153H4.64c-.784 0-1.176 0-1.476-.153a1.4 1.4 0 0 1-.611-.611c-.153-.3-.153-.692-.153-1.476V7.3M1 4.92v1.26c0 .392 0 .588.076.738a.7.7 0 0 0 .306.306c.15.076.346.076.738.076h11.76c.392 0 .588 0 .738-.076a.7.7 0 0 0 .306-.306C15 6.768 15 6.572 15 6.18V4.92c0-.392 0-.588-.076-.738a.7.7 0 0 0-.306-.306c-.15-.076-.346-.076-.738-.076H2.12c-.392 0-.588 0-.738.076a.7.7 0 0 0-.306.306C1 4.332 1 4.528 1 4.92Z",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

/* harmony default export */ __webpack_exports__["Z"] = (SvgIconGift);

/***/ }),

/***/ 59950:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconMoon = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M15 10.274A7.324 7.324 0 0 1 5.309.583 7.325 7.325 0 1 0 15 10.274Z",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

/* harmony default export */ __webpack_exports__["Z"] = (SvgIconMoon);

/***/ }),

/***/ 25056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconPrevious = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  width: 26,
  height: 12,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M5.06 10 2 5.954m0 0L4.999 2M2 5.954l23 .1",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "square"
})));

/* harmony default export */ __webpack_exports__["Z"] = (SvgIconPrevious);

/***/ }),

/***/ 16971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _form_CustomField__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56375);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(49727);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41197);
/* harmony import */ var _helpers_withModifiers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34495);
/* harmony import */ var react_scroll__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66261);
/* harmony import */ var _providers_ResponsiveContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40670);










var DropdownField = function(_param) {
    var _variant = _param.variant, variant = _variant === void 0 ? [] : _variant, children = _param.children, isActive = _param.isActive, shadowRef = _param.shadowRef, onClear = _param.onClear, onApply = _param.onApply, _angle = _param.angle, angle = _angle === void 0 ? true : _angle, _footer = _param.footer, footer = _footer === void 0 ? true : _footer, disableClear = _param.disableClear, disableApply = _param.disableApply, _scrollTop = _param.scrollTop, scrollTop = _scrollTop === void 0 ? false : _scrollTop, clearTranslation = _param.clearTranslation, applyTranslation = _param.applyTranslation, triggerClose = _param.triggerClose, _defaultOpen = _param.defaultOpen, defaultOpen = _defaultOpen === void 0 ? false : _defaultOpen, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "variant",
        "children",
        "isActive",
        "shadowRef",
        "onClear",
        "onApply",
        "angle",
        "footer",
        "disableClear",
        "disableApply",
        "scrollTop",
        "clearTranslation",
        "applyTranslation",
        "triggerClose",
        "defaultOpen"
    ]);
    var isLaptop = (0,_providers_ResponsiveContext__WEBPACK_IMPORTED_MODULE_5__/* .useResponsive */ .F)().isLaptop;
    var wrapperRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var contentRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(defaultOpen), show = ref[0], setShow = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(defaultOpen), contentVisible = ref1[0], setContentVisible = ref1[1];
    var isSimple = variant.length !== 0 && variant.includes("content-simple");
    var scroll = react_scroll__WEBPACK_IMPORTED_MODULE_4__["default"].animateScroll;
    // Handle click outside to close dropdown
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var handleClickOutside = function handleClickOutside(event) {
            if (!defaultOpen) {
                if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                    setShow(false);
                }
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    // Handle triggerClose prop changes
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        triggerClose && setShow(false);
    }, [
        triggerClose
    ]);
    // Handle shadow effect when dropdown is visible
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (shadowRef && !defaultOpen) {
            if (show) {
                var ref;
                (ref = shadowRef.current) === null || ref === void 0 ? void 0 : ref.classList.add("isVisible");
            } else {
                var ref1;
                (ref1 = shadowRef.current) === null || ref1 === void 0 ? void 0 : ref1.classList.remove("isVisible");
            }
        }
    }, [
        shadowRef,
        show
    ]);
    // Handle content visibility for render optimization
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (show) {
            // Make content visible immediately when showing
            setContentVisible(true);
        } else {
            // Add delay to hide content after transition completes
            var timer = setTimeout(function() {
                setContentVisible(false);
            }, 300) // Adjust timing to match your CSS transition duration
            ;
            return function() {
                return clearTimeout(timer);
            };
        }
    }, [
        show
    ]);
    // Handle clear action
    var handleClear = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        onClear && onClear();
        setShow(false);
        if (scrollTop) {
            scroll.scrollToTop();
        }
    }, [
        onClear,
        scrollTop,
        scroll
    ]);
    // Handle apply action
    var handleApply = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        onApply && onApply();
        setShow(false);
        if (scrollTop) {
            scroll.scrollToTop();
        }
    }, [
        onApply,
        scrollTop,
        scroll
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        ref: wrapperRef,
        className: (0,_helpers_withModifiers__WEBPACK_IMPORTED_MODULE_7__/* .withModifiers */ .i)("field", variant, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default())),
        role: "group",
        "aria-labelledby": "formik-group",
        children: [
            isSimple ? !isLaptop && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().field__label),
                children: props.value
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_form_CustomField__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                variant: variant,
                type: "text",
                readOnly: true,
                angle: angle,
                isActive: isActive || show,
                onClick: function() {
                    return setShow(!show);
                }
            }, props)),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                ref: contentRef,
                className: (0,_helpers_withModifiers__WEBPACK_IMPORTED_MODULE_7__/* .withModifiers */ .i)("field__content", [
                    show && "is-active"
                ], (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default())),
                "aria-hidden": !show,
                children: (contentVisible || show) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().field__wrapper),
                    children: [
                        isSimple && isLaptop && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().field__label),
                            children: props.value
                        }),
                        children,
                        footer && !isSimple && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().field__footer),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_3__["default"], {
                                    onClick: handleClear,
                                    disabled: disableClear,
                                    arrow: false,
                                    variant: [
                                        "xs",
                                        "secondary",
                                        "-offset-left"
                                    ],
                                    children: clearTranslation
                                }),
                                onApply && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_3__["default"], {
                                    variant: [
                                        "xs"
                                    ],
                                    arrow: false,
                                    onClick: handleApply,
                                    type: "submit",
                                    disabled: disableApply,
                                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().footer),
                                    children: applyTranslation
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DropdownField);


/***/ }),

/***/ 96143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42998);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _helpers_withModifiers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34495);




var LineSeparator = function(param) {
    var _width = param.width, width = _width === void 0 ? false : _width, _variant = param.variant, variant = _variant === void 0 ? [] : _variant;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: width ? {
            width: width
        } : {},
        className: (0,_helpers_withModifiers__WEBPACK_IMPORTED_MODULE_1__/* .withModifiers */ .i)("separator", (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(variant), (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default()))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LineSeparator);


/***/ }),

/***/ 50331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78897);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _helpers_withModifiers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34495);



var Spinner = function(param) {
    var _variant = param.variant, variant = _variant === void 0 ? [] : _variant;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_helpers_withModifiers__WEBPACK_IMPORTED_MODULE_1__/* .withModifiers */ .i)("spinner", variant, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default()))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Spinner);


/***/ }),

/***/ 92448:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_ModalContent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/elements/form/CustomField/index.js + 1 modules
var CustomField = __webpack_require__(56375);
// EXTERNAL MODULE: ./components/elements/Button/index.js + 2 modules
var Button = __webpack_require__(41197);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 1 modules
var formik_esm = __webpack_require__(64636);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/elements/form/Radio/index.js
var Radio = __webpack_require__(87048);
// EXTERNAL MODULE: ./providers/modalProvider.js
var modalProvider = __webpack_require__(51472);
// EXTERNAL MODULE: ./components/configs/axios.js
var axios = __webpack_require__(92375);
;// CONCATENATED MODULE: ./public/icons/icon-book-confirm.svg
var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconBookConfirm = props => /*#__PURE__*/react.createElement("svg", _extends({
  width: 30,
  height: 35,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
  d: "M20.672 15.699c-.28.004-.548.115-.748.312l-4.026 3.92-4.027 3.919-1.548-3.634a1.09 1.09 0 0 0-1.438-.592 1.084 1.084 0 0 0-.56 1.45l2.173 5.085a1.086 1.086 0 0 0 1.758.355l9.186-8.944c.322-.31.422-.786.253-1.199a1.089 1.089 0 0 0-1.023-.672Z",
  fill: "#B18D3B"
})), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
  d: "M7.683 0a1.087 1.087 0 0 0-1.068 1.1v1.33h-5.03a1.316 1.316 0 0 0-.103 0c-.557.056-.98.524-.98 1.083v6.442c-.003.05-.003.1 0 .151v23.597c-.001.6.482 1.09 1.083 1.091h26.837c.6-.001 1.085-.49 1.083-1.09V10.124c.004-.06.004-.12 0-.178V3.513a1.087 1.087 0 0 0-1.083-1.082h-5.03V1.099a1.089 1.089 0 1 0-2.174 0v1.332H8.789V1.099A1.083 1.083 0 0 0 7.683 0ZM2.676 4.604h3.94V5.93a1.089 1.089 0 0 0 1.864.784c.204-.21.316-.492.31-.784V4.604h12.427V5.93a1.086 1.086 0 1 0 2.174 0V4.604h3.94v4.34H2.675v-4.34Zm0 6.514H27.33V32.62H2.676V11.118Z",
  fill: "#999"
})));

/* harmony default export */ var icon_book_confirm = (SvgIconBookConfirm);
// EXTERNAL MODULE: ./node_modules/lodash-es/capitalize.js
var capitalize = __webpack_require__(26786);
// EXTERNAL MODULE: ./components/pages/single-property/components/Card/components/Reservation/components/ModalContent/ThankYou/styles.module.scss
var styles_module = __webpack_require__(37691);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./providers/SearchContext.js
var SearchContext = __webpack_require__(65079);
;// CONCATENATED MODULE: ./components/pages/single-property/components/Card/components/Reservation/components/ModalContent/ThankYou/index.js












var ThankYou = function(param) {
    var setFieldValue = param.setFieldValue, translations = param.translations;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(""), transport = ref[0], setTransport = ref[1];
    var ref1 = (0,react.useState)(""), details = ref1[0], setDetails = ref1[1];
    var ref2 = (0,react.useState)(""), pets = ref2[0], setPets = ref2[1];
    var ref3 = (0,react.useState)(""), arrangements = ref3[0], setArrangements = ref3[1];
    var ref4 = (0,react.useState)(""), grocery = ref4[0], setGrocery = ref4[1];
    var ref5 = (0,react.useState)(""), phone = ref5[0], setPhone = ref5[1];
    var ref6 = (0,SearchContext/* useSearchContext */.AB)(), setReset = ref6.setReset, setReserved = ref6.setReserved;
    (0,react.useEffect)(function() {
        setReset(true);
        setReserved(true);
        setTimeout(function() {
            setReset(false);
            setReserved(false);
        }, 100);
    }, []);
    var checkboxesUnknown = [
        translations === null || translations === void 0 ? void 0 : translations.yes[router.locale],
        translations === null || translations === void 0 ? void 0 : translations.no[router.locale],
        translations === null || translations === void 0 ? void 0 : translations.unknown[router.locale]
    ];
    var checkboxes = [
        translations === null || translations === void 0 ? void 0 : translations.yes[router.locale],
        translations === null || translations === void 0 ? void 0 : translations.no[router.locale]
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
        className: classnames_default()((styles_module_default()).form, (styles_module_default()).thanks),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).form__intro,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_book_confirm, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: (styles_module_default()).form__title,
                        children: translations === null || translations === void 0 ? void 0 : translations.title[router.locale]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: translations === null || translations === void 0 ? void 0 : translations.subtitle[router.locale]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: (styles_module_default()).form__label,
                children: translations === null || translations === void 0 ? void 0 : translations.phoneNumber[router.locale]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomField/* default */.Z, {
                name: "phone",
                optional: true,
                onChange: function(e) {
                    setFieldValue("phone", e.target.value.replace(/[^0-9+()]/g, ""));
                    setPhone(e.target.value.replace(/[^0-9+()]/g, ""));
                },
                value: phone,
                type: "tel",
                variant: [
                    "full-width",
                    "white"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: (styles_module_default()).form__label,
                children: translations === null || translations === void 0 ? void 0 : translations.rentCar[router.locale]
            }),
            checkboxes.map(function(item, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                    variant: [
                        "white"
                    ],
                    name: "car",
                    checkbox: true,
                    value: item,
                    label: (0,capitalize/* default */.Z)(item),
                    checked: transport === item,
                    onChange: function(e) {
                        setTransport(e.target.value);
                        setFieldValue("car", e.target.value);
                    }
                }, "car-".concat(index));
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (styles_module_default()).form__additional,
                children: translations === null || translations === void 0 ? void 0 : translations.rentCarNote[router.locale]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: (styles_module_default()).form__label,
                children: translations === null || translations === void 0 ? void 0 : translations.transport[router.locale]
            }),
            checkboxes.map(function(item, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                    variant: [
                        "white"
                    ],
                    name: "transport",
                    checkbox: true,
                    value: item,
                    label: (0,capitalize/* default */.Z)(item),
                    checked: pets === item,
                    onChange: function(e) {
                        setPets(e.target.value);
                        setFieldValue("transport", e.target.value);
                    }
                }, "transport-".concat(index));
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (styles_module_default()).form__additional,
                children: translations === null || translations === void 0 ? void 0 : translations.transportNote[router.locale]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: (styles_module_default()).form__label,
                children: translations === null || translations === void 0 ? void 0 : translations.assistance[router.locale]
            }),
            checkboxesUnknown.map(function(item, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                    variant: [
                        "white"
                    ],
                    name: "assistance",
                    checkbox: true,
                    value: item,
                    label: (0,capitalize/* default */.Z)(item),
                    checked: arrangements === item,
                    onChange: function(e) {
                        setArrangements(e.target.value);
                        setFieldValue("assistance", e.target.value);
                    }
                }, "assistance-".concat(index));
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (styles_module_default()).form__additional,
                children: translations === null || translations === void 0 ? void 0 : translations.assistanceNote[router.locale]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: (styles_module_default()).form__label,
                children: translations === null || translations === void 0 ? void 0 : translations.food[router.locale]
            }),
            checkboxesUnknown.map(function(item, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                    variant: [
                        "white"
                    ],
                    name: "food",
                    checkbox: true,
                    value: item,
                    label: (0,capitalize/* default */.Z)(item),
                    checked: grocery === item,
                    onChange: function(e) {
                        setGrocery(e.target.value);
                        setFieldValue("food", e.target.value);
                    }
                }, "food-".concat(index));
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: (styles_module_default()).form__label,
                children: translations === null || translations === void 0 ? void 0 : translations.foodNote[router.locale]
            }),
            checkboxesUnknown.map(function(item, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                    variant: [
                        "white"
                    ],
                    name: "reservation",
                    checkbox: true,
                    value: item,
                    label: (0,capitalize/* default */.Z)(item),
                    checked: details === item,
                    onChange: function(e) {
                        setDetails(e.target.value);
                        setFieldValue("reservation", e.target.value);
                    }
                }, "reservation-".concat(index));
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                arrow: false,
                className: (styles_module_default()).form__submit,
                variant: [
                    "color-accent"
                ],
                children: translations === null || translations === void 0 ? void 0 : translations.submit[router.locale]
            })
        ]
    });
};
/* harmony default export */ var ModalContent_ThankYou = (ThankYou);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@stripe/react-stripe-js/dist/react-stripe.umd.js
var react_stripe_umd = __webpack_require__(86664);
// EXTERNAL MODULE: ./node_modules/@stripe/stripe-js/pure.js
var pure = __webpack_require__(97894);
// EXTERNAL MODULE: ./components/pages/single-property/StripeComponent/styles.module.scss
var StripeComponent_styles_module = __webpack_require__(39361);
var StripeComponent_styles_module_default = /*#__PURE__*/__webpack_require__.n(StripeComponent_styles_module);
// EXTERNAL MODULE: ./components/elements/Spinner/index.js
var Spinner = __webpack_require__(50331);
;// CONCATENATED MODULE: ./components/pages/single-property/StripeComponent/checkoutForm.js










var CheckoutForm = function(param) {
    var total = param.total, propertyId = param.propertyId, listingId = param.listingId, startDate = param.startDate, endDate = param.endDate, bedrooms = param.bedrooms, email = param.email, firstName = param.firstName, lastName = param.lastName, setPlans = param.setPlans, guests = param.guests, setReservationId = param.setReservationId, propertyName = param.propertyName, coupon = param.coupon, setSkip = param.setSkip, bonuses = param.bonuses, freeNights = param.freeNights, freeNightlyRate = param.freeNightlyRate, initialPrice = param.initialPrice, translations = param.translations, _manually_blocked = param.manually_blocked, manually_blocked = _manually_blocked === void 0 ? false : _manually_blocked, _status = param.status, status = _status === void 0 ? "pending" : _status;
    var ref = (0,react.useState)(null), message = ref[0], setMessage = ref[1];
    var ref1 = (0,react.useState)(null), errorMessage = ref1[0], setErrorMessage = ref1[1];
    var ref2 = (0,react.useState)(false), isLoading = ref2[0], setIsLoading = ref2[1];
    var ref3 = (0,react.useState)(false), paymentDone = ref3[0], setPaymentDone = ref3[1];
    var stripe = (0,react_stripe_umd.useStripe)();
    var elements = (0,react_stripe_umd.useElements)();
    var router = (0,next_router.useRouter)();
    if (!stripe || !elements) {
        return;
    }
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.preventDefault();
                        setIsLoading(true);
                        axios/* default.post */.Z.post("reservation/price-calculation", {
                            lang: router.locale,
                            id: propertyId,
                            total: total * 100,
                            startDate: startDate,
                            endDate: endDate,
                            bedrooms: bedrooms
                        }).then((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                            var ref, error, paymentMethod, id;
                            return runtime_default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        _ctx.next = 2;
                                        return stripe.createPaymentMethod({
                                            type: "card",
                                            card: elements.getElement(react_stripe_umd.CardElement)
                                        });
                                    case 2:
                                        ref = _ctx.sent;
                                        error = ref.error;
                                        paymentMethod = ref.paymentMethod;
                                        if (!error) {
                                            try {
                                                id = paymentMethod.id;
                                                axios/* default.post */.Z.post("reservation/payment-intent", {
                                                    amount: total * 100,
                                                    firstName: firstName,
                                                    lastName: lastName,
                                                    email: email
                                                }).then(function(response) {
                                                    if (response.status === 200) {
                                                        var clientKey = response.data[0];
                                                        var paymentIntentId = response.data[1];
                                                        var customerId = response.data[2];
                                                        stripe// eslint-disable-next-line no-undef
                                                        .confirmCardPayment(clientKey, {
                                                            payment_method: {
                                                                card: elements.getElement(react_stripe_umd.CardElement),
                                                                billing_details: {
                                                                    name: firstName + " " + lastName
                                                                }
                                                            }
                                                        }).then(function(response) {
                                                            if (response.paymentIntent) {
                                                                axios/* default.post */.Z.post("reservation/guesty", {
                                                                    firstName: firstName,
                                                                    lastName: lastName,
                                                                    email: email,
                                                                    startDate: startDate,
                                                                    endDate: endDate,
                                                                    propertyId: propertyId,
                                                                    listingId: listingId,
                                                                    amount: total * 100,
                                                                    paymentIntentId: paymentIntentId,
                                                                    customerId: customerId,
                                                                    coupon: coupon,
                                                                    id: id,
                                                                    guests: guests,
                                                                    bonuses: bonuses,
                                                                    freeNights: freeNights,
                                                                    freeNightlyRate: freeNightlyRate,
                                                                    initialPrice: initialPrice,
                                                                    manually_blocked: manually_blocked
                                                                }).then(function(response) {
                                                                    // Confirm payment email notification
                                                                    axios/* default.post */.Z.post("email/reservation", {
                                                                        total: total,
                                                                        propertyName: propertyName,
                                                                        startDate: startDate,
                                                                        endDate: endDate,
                                                                        bedrooms: bedrooms,
                                                                        email: email,
                                                                        firstName: firstName,
                                                                        lastName: lastName,
                                                                        guests: guests,
                                                                        coupon: coupon,
                                                                        bonuses: bonuses,
                                                                        freeNights: freeNights,
                                                                        freeNightlyRate: freeNightlyRate,
                                                                        initialPrice: initialPrice
                                                                    }).then(function() {
                                                                        setIsLoading(false);
                                                                        setMessage(translations === null || translations === void 0 ? void 0 : translations.paymentSucceeded[router.locale]);
                                                                        setPaymentDone(true);
                                                                        setReservationId(response.data.reservationId);
                                                                        setTimeout(function() {
                                                                            setMessage(null);
                                                                            setPlans("thankYou");
                                                                        }, 2000);
                                                                    });
                                                                });
                                                            } else {
                                                                setIsLoading(false);
                                                                setErrorMessage(response.error.message);
                                                                // Payment failed email notification
                                                                axios/* default.post */.Z.post("email/payment", {
                                                                    total: total,
                                                                    propertyName: propertyName,
                                                                    startDate: startDate,
                                                                    endDate: endDate,
                                                                    bedrooms: bedrooms,
                                                                    email: email,
                                                                    firstName: firstName,
                                                                    lastName: lastName,
                                                                    guests: guests,
                                                                    coupon: coupon,
                                                                    bonuses: bonuses,
                                                                    freeNights: freeNights,
                                                                    freeNightlyRate: freeNightlyRate,
                                                                    initialPrice: initialPrice
                                                                });
                                                                setTimeout(function() {
                                                                    setErrorMessage(null);
                                                                }, 8000);
                                                            }
                                                        });
                                                    }
                                                });
                                            } catch (error1) {
                                                setIsLoading(false);
                                            }
                                        } else {
                                            setIsLoading(false);
                                            setErrorMessage(error.message);
                                        }
                                    case 6:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee);
                        }))).catch(function() {
                            setIsLoading(false);
                            setMessage(translations === null || translations === void 0 ? void 0 : translations.error[router.locale]);
                        });
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                className: (StripeComponent_styles_module_default()).payment_form,
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_stripe_umd.CardElement, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                        variant: [
                            "color-accent",
                            "full-width"
                        ],
                        arrow: !isLoading,
                        disabled: isLoading || !stripe || !elements || paymentDone,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            id: "button-text",
                            children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (StripeComponent_styles_module_default()).label,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {}),
                                    translations === null || translations === void 0 ? void 0 : translations.confirming[router.locale]
                                ]
                            }) : translations === null || translations === void 0 ? void 0 : translations.confirm[router.locale]
                        })
                    }),
                    message && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (StripeComponent_styles_module_default()).payment_message,
                        children: message
                    }),
                    errorMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (StripeComponent_styles_module_default()).payment_error_message,
                        children: errorMessage
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: translations === null || translations === void 0 ? void 0 : translations.note[router.locale]
                        },
                        className: (StripeComponent_styles_module_default()).note
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (StripeComponent_styles_module_default()).skip,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                        variant: [
                            "label",
                            "xs"
                        ],
                        onClick: function() {
                            return(// Skip payment email notification
                            axios/* default.post */.Z.post("email/skip-payment", {
                                propertyId: propertyId,
                                listingId: listingId,
                                total: total,
                                propertyName: propertyName,
                                startDate: startDate,
                                endDate: endDate,
                                bedrooms: bedrooms,
                                email: email,
                                firstName: firstName,
                                lastName: lastName,
                                guests: guests,
                                coupon: coupon,
                                bonuses: bonuses,
                                freeNights: freeNights,
                                freeNightlyRate: freeNightlyRate,
                                initialPrice: initialPrice,
                                manually_blocked: manually_blocked,
                                status: status
                            }).then(function() {
                                setMessage(null);
                                setPlans("finish");
                                setSkip(true);
                            }));
                        },
                        children: translations === null || translations === void 0 ? void 0 : translations.skip[router.locale]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: translations === null || translations === void 0 ? void 0 : translations.skipNote[router.locale]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var checkoutForm = (CheckoutForm);

;// CONCATENATED MODULE: ./components/pages/single-property/StripeComponent/index.js








var options = {
};
var StripeComponent = function(props) {
    var ref = (0,react.useState)(null), stripe = ref[0], setStripe = ref[1];
    (0,react.useEffect)(function() {
        var fetchStripe = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var stripeInstance;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return (0,pure.loadStripe)(// eslint-disable-next-line no-undef
                            "pk_live_WIAkLmoBKTljfKkcGJEtTg3f");
                        case 2:
                            stripeInstance = _ctx.sent;
                            setStripe(stripeInstance);
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function fetchStripe() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchStripe();
    }, []);
    if (stripe) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_stripe_umd.Elements, {
            stripe: stripe,
            options: options,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(checkoutForm, (0,_object_spread/* default */.Z)({}, props))
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        children: "Loading Payment Method..."
    });
};
/* harmony default export */ var single_property_StripeComponent = (StripeComponent);

// EXTERNAL MODULE: ./components/layout/Column/index.js
var Column = __webpack_require__(70539);
// EXTERNAL MODULE: ./components/layout/Columns/index.js
var Columns = __webpack_require__(40050);
// EXTERNAL MODULE: ./public/icons/icon-screenshots-prev.svg
var icon_screenshots_prev = __webpack_require__(36133);
// EXTERNAL MODULE: ./public/icons/icon-screenshots-next.svg
var icon_screenshots_next = __webpack_require__(80242);
// EXTERNAL MODULE: ./components/elements/SlickSlider/index.js + 2 modules
var SlickSlider = __webpack_require__(12817);
// EXTERNAL MODULE: ./components/pages/single-property/components/Card/components/Reservation/components/ModalContent/Details/styles.module.scss
var Details_styles_module = __webpack_require__(61825);
var Details_styles_module_default = /*#__PURE__*/__webpack_require__.n(Details_styles_module);
// EXTERNAL MODULE: ./components/elements/LazyImage/index.js
var LazyImage = __webpack_require__(20027);
// EXTERNAL MODULE: ./components/helpers/withComma.js
var withComma = __webpack_require__(29828);
// EXTERNAL MODULE: ./components/helpers/withModifiers.js
var withModifiers = __webpack_require__(34495);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./components/pages/single-property/components/Card/components/Reservation/components/ModalContent/Details/index.js














var formatDate = function(date) {
    if (!date) return "";
    var d = moment_default()(date).utc();
    return d.format("MMM DD, YYYY");
};
var formatDateForAPI = function(date) {
    if (!date) return "";
    var d = moment_default()(date).utc();
    return d.format("YYYY-MM-DD");
};
var Details = function(param) {
    var property = param.property, startDate = param.startDate, endDate = param.endDate, bedrooms = param.bedrooms, guests = param.guests, setUpdatedPrice = param.setUpdatedPrice, updatedPrice = param.updatedPrice, setCoupon = param.setCoupon, totalWithoutStripe = param.totalWithoutStripe, taxesAndFess = param.taxesAndFess, totalCostPerNights = param.totalCostPerNights, bonuses = param.bonuses, numberOfFreeNights = param.numberOfFreeNights, freeNightsCost = param.freeNightsCost, freeNightsOldPrice = param.freeNightsOldPrice, translations = param.translations;
    var ref;
    var ref1 = (0,react.useState)(false), error = ref1[0], setError = ref1[1];
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Details_styles_module_default()).details,
        children: [
            property.pictures && /*#__PURE__*/ (0,jsx_runtime.jsx)(SlickSlider/* default */.Z, {
                nextArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_screenshots_next/* default */.Z, {}),
                prevArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_screenshots_prev/* default */.Z, {}),
                slidesToShow: 1,
                className: (Details_styles_module_default()).details__slider,
                children: property.pictures && property.pictures.slice(0, 7).map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage/* default */.Z, {
                        src: item.original,
                        index: true
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: (Details_styles_module_default()).details__title,
                children: property === null || property === void 0 ? void 0 : property.propertyTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,withModifiers/* withModifiers */.i)("details__row", [
                    "merged"
                ], (Details_styles_module_default())),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: translations.popup.arrival[router.locale]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: formatDate(startDate)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,withModifiers/* withModifiers */.i)("details__row", [
                    "merged"
                ], (Details_styles_module_default())),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: translations.popup.departure[router.locale]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: formatDate(endDate)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,withModifiers/* withModifiers */.i)("details__row", [
                    "merged"
                ], (Details_styles_module_default())),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: translations.popup.bedroom[router.locale]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (Details_styles_module_default()).details__bedroom,
                        children: bedrooms
                    })
                ]
            }),
            guests && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,withModifiers/* withModifiers */.i)("details__row", [
                    "merged"
                ], (Details_styles_module_default())),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: (ref = translations.popup) === null || ref === void 0 ? void 0 : ref.guests[router.locale]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: guests
                    })
                ]
            }),
            bonuses && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Details_styles_module_default()).details__row,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: translations.popup.bonuses[router.locale]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: Object.keys(bonuses).filter(function(bonus) {
                            return bonuses[bonus];
                        }).map(function(bonus, index, array) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    bonus === "night" && numberOfFreeNights && "".concat(numberOfFreeNights, " ").concat(translations.popup.free[router.locale], " "),
                                    bonus !== "night" && bonus.charAt(0).toUpperCase() + bonus.slice(1),
                                    bonus === "night" && (Number(numberOfFreeNights) > 1 ? translations.popup.night[router.locale] : translations.popup.nights[router.locale]),
                                    index !== array.length - 1 ? ", " : ""
                                ]
                            }, bonus);
                        })
                    })
                ]
            }),
            freeNightsOldPrice && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Details_styles_module_default()).details__row,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: translations.popup.oldPrice[router.locale]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            "$",
                            (0,withComma/* withComma */.u)(freeNightsOldPrice)
                        ]
                    })
                ]
            }),
            freeNightsCost !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,withModifiers/* withModifiers */.i)("details__row", [
                    "merged"
                ], (Details_styles_module_default())),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: translations.popup.freeNight[router.locale]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            "- $",
                            (0,withComma/* withComma */.u)(freeNightsCost)
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Details_styles_module_default()).details__row,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: translations.popup.total[router.locale]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            "$",
                            (0,withComma/* withComma */.u)(totalCostPerNights)
                        ]
                    })
                ]
            }),
            updatedPrice && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,withModifiers/* withModifiers */.i)("details__row", [
                    "merged"
                ], (Details_styles_module_default())),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: translations.popup.coupon[router.locale]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            "- $",
                            (0,withComma/* withComma */.u)(updatedPrice.discount)
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,withModifiers/* withModifiers */.i)("details__row", [
                    "merged"
                ], (Details_styles_module_default())),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: translations.popup.taxesFees[router.locale]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            "+ $",
                            updatedPrice ? (0,withComma/* withComma */.u)(updatedPrice.tax10) : (0,withComma/* withComma */.u)(taxesAndFess)
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Details_styles_module_default()).details__row,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: translations.popup.finalPrice[router.locale]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            "$",
                            updatedPrice ? (0,withComma/* withComma */.u)(updatedPrice.totalWith10Taxes) : (0,withComma/* withComma */.u)(totalWithoutStripe)
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: translations.popup.contact[router.locale]
                },
                className: (Details_styles_module_default()).details__note
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                enableReinitialize: true,
                initialValues: {
                    coupon: ""
                },
                validate: function(values) {
                    var errors = {};
                    if (values.email !== "") {
                        if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
                            errors.email = translations.form.error.validEmail[router.locale];
                        }
                    }
                    return errors;
                },
                children: function(param) {
                    var values = param.values, setFieldValue = param.setFieldValue, handleBlur = param.handleBlur, isSubmitting = param.isSubmitting;
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
                        className: (Details_styles_module_default()).form,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                variant: [
                                    "full-width"
                                ],
                                maxLength: 30,
                                placeholder: translations.popup.coupon[router.locale],
                                name: "coupon",
                                onChange: function(e) {
                                    setFieldValue("coupon", e.target.value.replace(/[^a-zA-Z0-9]/g, ""));
                                },
                                onBlur: handleBlur,
                                className: (Details_styles_module_default()).form__field
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                                variant: [
                                    "secondary"
                                ],
                                className: (Details_styles_module_default()).form__button,
                                disabled: isSubmitting,
                                onClick: function() {
                                    return axios/* default.post */.Z.post("reservation/price-calculation", {
                                        lang: router.locale,
                                        id: property === null || property === void 0 ? void 0 : property.resource_id,
                                        startDate: formatDateForAPI(startDate),
                                        endDate: formatDateForAPI(endDate),
                                        bedrooms: bedrooms,
                                        discountCode: values.coupon
                                    }).then(function(res) {
                                        var data = res.data;
                                        if (data.discount) {
                                            setUpdatedPrice(data);
                                            setCoupon(values.coupon);
                                            setError(false);
                                        } else {
                                            setError(true);
                                        }
                                    }).catch(function(error) {
                                        return setError(error.response.status);
                                    });
                                }
                            })
                        ]
                    });
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Details_styles_module_default()).form__error,
                children: error && translations.popup.invalidCoupon[router.locale]
            })
        ]
    });
};
/* harmony default export */ var ModalContent_Details = (Details);

;// CONCATENATED MODULE: ./public/icons/icon-step-contact.svg
var icon_step_contact_path, icon_step_contact_path2, _path3, _path4;

function icon_step_contact_extends() { icon_step_contact_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return icon_step_contact_extends.apply(this, arguments); }



const SvgIconStepContact = props => /*#__PURE__*/react.createElement("svg", icon_step_contact_extends({
  width: 32,
  height: 32,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), icon_step_contact_path || (icon_step_contact_path = /*#__PURE__*/react.createElement("path", {
  d: "M.421 13.562h5.31a.421.421 0 0 0 .422-.422.418.418 0 0 0-.422-.422H.421A.42.42 0 0 0 0 13.14c0 .236.186.422.421.422ZM.421 7.847h5.31a.42.42 0 0 0 .422-.422.418.418 0 0 0-.422-.422H.421A.42.42 0 0 0 0 7.425c0 .236.186.422.421.422ZM.421 19.278h5.31a.421.421 0 0 0 .422-.422.418.418 0 0 0-.422-.422H.421a.42.42 0 0 0-.421.422c0 .236.186.422.421.422Z",
  fill: "#999"
})), icon_step_contact_path2 || (icon_step_contact_path2 = /*#__PURE__*/react.createElement("path", {
  d: "M28.003 0H6.653a4.004 4.004 0 0 0-3.997 4.002.42.42 0 1 0 .843 0A3.164 3.164 0 0 1 6.656.84h21.347c1.74 0 3.157 1.42 3.157 3.162v23.996a3.164 3.164 0 0 1-3.157 3.162H6.653a3.164 3.164 0 0 1-3.158-3.162.42.42 0 1 0-.843 0A4.005 4.005 0 0 0 6.648 32h21.355A4.005 4.005 0 0 0 32 27.998V4.002A4.004 4.004 0 0 0 28.003 0Z",
  fill: "#999"
})), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
  d: "M6.153 24.576a.42.42 0 0 0-.422-.423H.421a.418.418 0 0 0-.421.423c0 .235.186.422.421.422h5.314a.42.42 0 0 0 .422-.422h-.004Z",
  fill: "#999"
})), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
  d: "M21.578 11.087a3.94 3.94 0 0 0-3.93-3.936 3.94 3.94 0 0 0-3.93 3.936 3.94 3.94 0 0 0 3.93 3.936 3.937 3.937 0 0 0 3.93-3.936Zm-7.016 0a3.092 3.092 0 0 1 3.086-3.091 3.092 3.092 0 0 1 0 6.183 3.092 3.092 0 0 1-3.086-3.092ZM23.494 17.208c-.851-.985-2.066-1.485-3.603-1.485a.386.386 0 0 0-.28.132l-.013-.012s-.744.703-1.946.703c-1.203 0-1.942-.695-1.947-.703l-.012.012a.411.411 0 0 0-.285-.132c-1.537 0-2.752.5-3.603 1.485-1.785 2.066-1.314 5.5-1.29 5.646a.42.42 0 0 0 .418.36h13.433a.426.426 0 0 0 .417-.36c.021-.145.492-3.58-1.289-5.646Zm-3.343-.637c1.157.05 2.066.451 2.707 1.188 1.223 1.415 1.194 3.729 1.132 4.614H11.31c-.066-.885-.095-3.19 1.128-4.614.636-.74 1.55-1.138 2.707-1.192.462.269 1.222.596 1.222.596a3.793 3.793 0 0 0 2.562 0s.736-.302 1.22-.596l.003.004Z",
  fill: "#B18D3B"
})));

/* harmony default export */ var icon_step_contact = (SvgIconStepContact);
;// CONCATENATED MODULE: ./public/icons/icon-step-payment.svg
var icon_step_payment_path, icon_step_payment_path2, icon_step_payment_path3;

function icon_step_payment_extends() { icon_step_payment_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return icon_step_payment_extends.apply(this, arguments); }



const SvgIconStepPayment = props => /*#__PURE__*/react.createElement("svg", icon_step_payment_extends({
  width: 32,
  height: 32,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), icon_step_payment_path || (icon_step_payment_path = /*#__PURE__*/react.createElement("path", {
  d: "m30.206 15.13-3.31-1.26V2.79c0-1.54-1.25-2.79-2.791-2.79H2.79C1.25 0 0 1.25 0 2.79v12.28c0 1.54 1.25 2.79 2.79 2.79h.58l-1.05 2.77c-.55 1.44.18 3.05 1.61 3.6l19.915 7.59c.32.12.66.18.99.18.39 0 .78-.08 1.14-.25.68-.31 1.2-.86 1.47-1.55l4.372-11.47c.55-1.44-.18-3.05-1.61-3.6ZM.8 15.06V2.79C.8 1.69 1.69.8 2.79.8h21.315c1.1 0 1.99.9 1.99 1.99v12.28c0 1.1-.89 1.99-1.99 1.99H2.79c-1.1 0-1.99-.9-1.99-1.99v-.01Zm28.996 6.73-10.332-3.94h4.64c.481 0 .931-.12 1.331-.34l5.231 1.99-.87 2.28v.01Zm-3.1 8.12c-.19.5-.56.89-1.05 1.11-.49.22-1.031.23-1.521.05L4.22 23.48a1.997 1.997 0 0 1-1.15-2.57l1.16-3.05h13.022s.03.02.05.03l12.213 4.65-2.81 7.38-.01-.01Zm4.37-11.47-.12.31-4.79-1.82c.45-.5.73-1.15.73-1.87v-.34l3.02 1.15c1.02.39 1.54 1.54 1.15 2.57h.01Z",
  fill: "#999"
})), icon_step_payment_path2 || (icon_step_payment_path2 = /*#__PURE__*/react.createElement("path", {
  d: "M3.572 10.74c-.22 0-.4.18-.4.4 0 .22.18.4.4.4h3.35c.22 0 .4-.18.4-.4 0-.22-.18-.4-.4-.4h-3.35ZM12.172 10.74h-3.35c-.22 0-.4.18-.4.4 0 .22.18.4.4.4h3.35c.22 0 .4-.18.4-.4 0-.22-.18-.4-.4-.4ZM17.426 10.74h-3.35c-.22 0-.4.18-.4.4 0 .22.18.4.4.4h3.35c.22 0 .4-.18.4-.4 0-.22-.18-.4-.4-.4ZM17.402 13.81h-3.35c-.22 0-.4.18-.4.4 0 .22.18.4.4.4h3.35c.22 0 .4-.18.4-.4 0-.22-.18-.4-.4-.4ZM22.664 10.74h-3.35c-.22 0-.4.18-.4.4 0 .22.18.4.4.4h3.35c.22 0 .4-.18.4-.4 0-.22-.18-.4-.4-.4ZM13.455 4.05h9.202c.22 0 .4-.18.4-.4 0-.22-.18-.4-.4-.4h-9.202c-.22 0-.4.18-.4.4 0 .22.18.4.4.4ZM23.047 6.72c0-.22-.18-.4-.4-.4h-9.192c-.22 0-.4.18-.4.4 0 .22.18.4.4.4h9.202c.22 0 .4-.18.4-.4h-.01ZM12.152 13.81H3.56c-.22 0-.4.18-.4.4 0 .22.18.4.4.4h8.592c.22 0 .4-.18.4-.4 0-.22-.18-.4-.4-.4ZM4.209 8.65h3.29c.58 0 1.05-.47 1.05-1.05V4.31c0-.58-.47-1.06-1.05-1.06H4.21c-.58 0-1.06.47-1.06 1.06V7.6c0 .58.47 1.05 1.06 1.05Zm-.25-4.34c0-.14.11-.26.26-.26h3.29c.14 0 .25.11.25.26V7.6c0 .14-.11.25-.25.25H4.22c-.14 0-.26-.11-.26-.25V4.31Z",
  fill: "#999"
})), icon_step_payment_path3 || (icon_step_payment_path3 = /*#__PURE__*/react.createElement("path", {
  d: "m8.299 19.37-1.38-.52a.399.399 0 0 0-.52.23c-.08.21.02.44.23.52l1.38.52s.1.03.14.03c.16 0 .31-.1.37-.26a.399.399 0 0 0-.23-.52h.01ZM11.318 20.54l-1.38-.52a.399.399 0 0 0-.52.23c-.08.21.02.44.23.52l1.38.52s.1.03.14.03c.16 0 .31-.1.37-.26a.399.399 0 0 0-.23-.52h.01ZM14.353 21.71l-1.38-.52a.399.399 0 0 0-.52.23c-.08.21.02.44.23.52l1.38.52s.1.03.14.03c.16 0 .31-.1.37-.26a.399.399 0 0 0-.23-.52h.01ZM23.597 22.09c-.48-.18-.98-.25-1.48-.2-.33-.36-.75-.65-1.23-.83-.82-.31-1.72-.29-2.531.07-.81.36-1.42 1.01-1.74 1.84a3.316 3.316 0 0 0 3.09 4.49c.1 0 .2 0 .3-.02.33.36.75.65 1.23.83.38.15.78.22 1.18.22.46 0 .92-.1 1.351-.29.81-.36 1.42-1.01 1.74-1.84.65-1.7-.21-3.62-1.91-4.27Zm-1.55 2.95a2.55 2.55 0 0 1-1.32 1.4c-.13.06-.26.1-.39.14a2.51 2.51 0 0 1-.26-2.28c.24-.62.71-1.12 1.32-1.4.13-.06.26-.1.39-.14.43.65.56 1.5.26 2.28Zm-3.231 1.45a2.514 2.514 0 0 1-1.45-3.24c.24-.62.71-1.12 1.32-1.4.33-.15.67-.22 1.02-.22.3 0 .6.05.89.17.21.08.4.19.58.32-.04.01-.07.03-.11.04-.81.36-1.42 1.01-1.74 1.84-.34.89-.26 1.84.13 2.64-.22-.02-.43-.07-.65-.15h.01Zm5.951-.41a2.55 2.55 0 0 1-1.32 1.4c-.61.27-1.29.29-1.92.05-.21-.08-.41-.19-.58-.32.04-.01.07-.03.11-.04.81-.36 1.42-1.01 1.74-1.84.34-.89.26-1.83-.12-2.63.22.02.43.06.64.14 1.29.49 1.94 1.94 1.45 3.24Z",
  fill: "#B18D3B"
})));

/* harmony default export */ var icon_step_payment = (SvgIconStepPayment);
// EXTERNAL MODULE: ./providers/ResponsiveContext.js
var ResponsiveContext = __webpack_require__(40670);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 24 modules
var es = __webpack_require__(98077);
;// CONCATENATED MODULE: ./components/pages/single-property/components/Card/components/Reservation/components/ModalContent/index.js























var ModalContent = function(param) {
    var propertyId = param.propertyId, guests = param.guests, total = param.total, bedrooms = param.bedrooms, property = param.property, taxesAndFess = param.taxesAndFess, totalCostPerNights = param.totalCostPerNights, totalWithoutStripe = param.totalWithoutStripe, bonuses = param.bonuses, numberOfFreeNights = param.numberOfFreeNights, freeNightsCost = param.freeNightsCost, freeNightsOldPrice = param.freeNightsOldPrice, translations = param.translations;
    var router = (0,next_router.useRouter)();
    var search = (0,SearchContext/* useSearchContext */.AB)().search;
    var startDate = search.startDate;
    var endDate = search.endDate;
    var ReservationSchema = es/* object */.Ry().shape({
        firstName: es/* string */.Z_().max(25).matches(RegExp("^'?\\p{L}+(?:[' ]\\p{L}+)*'?$", "u"), translations.form.error.validName[router.locale]).required(translations.form.error.requiredFirstName[router.locale]),
        lastName: es/* string */.Z_().max(25).matches(RegExp("^'?\\p{L}+(?:[' ]\\p{L}+)*'?$", "u"), translations.form.error.validName[router.locale]).required(translations.form.error.requiredLastName[router.locale]),
        email: es/* string */.Z_().matches(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/).max(254).email(translations.form.error.validEmail[router.locale]).required(translations.form.error.requiredEmail[router.locale])
    });
    var handleCloseModal = (0,modalProvider/* useModalContext */.vR)().handleCloseModal;
    var isMobile = (0,ResponsiveContext/* useResponsive */.F)().isMobile;
    var ref = (0,react.useState)("details"), plans = ref[0], setPlans = ref[1];
    var ref1 = (0,react.useState)(false), skip = ref1[0], setSkip = ref1[1];
    var ref2 = (0,react.useState)(false), coupon = ref2[0], setCoupon = ref2[1];
    var ref3 = (0,react.useState)(false), updatedPrice = ref3[0], setUpdatedPrice = ref3[1];
    var ref4 = (0,react.useState)(""), reservationId = ref4[0], setReservationId = ref4[1];
    var ref5 = (0,react.useState)(false), agreement = ref5[0], setAgreement = ref5[1];
    var isThankYou = plans === "thankYou";
    var detailsProps = {
        guests: guests,
        total: total,
        startDate: startDate,
        endDate: endDate,
        bedrooms: bedrooms,
        property: property,
        updatedPrice: updatedPrice,
        setUpdatedPrice: setUpdatedPrice,
        setCoupon: setCoupon,
        taxesAndFess: taxesAndFess,
        totalCostPerNights: totalCostPerNights,
        totalWithoutStripe: totalWithoutStripe,
        bonuses: bonuses,
        numberOfFreeNights: numberOfFreeNights,
        freeNightsCost: freeNightsCost,
        freeNightsOldPrice: freeNightsOldPrice,
        translations: translations
    };
    var formInitialValues = {
        id: propertyId,
        startDate: startDate,
        endDate: endDate,
        bedrooms: bedrooms,
        total: Number(total),
        guests: guests,
        bonuses: bonuses,
        propertyName: property === null || property === void 0 ? void 0 : property.propertyTitle,
        firstName: "",
        lastName: "",
        email: "",
        agreement: false,
        phone: null,
        car: null,
        transport: null,
        assistance: null,
        food: null,
        reservation: null
    };
    var ref6 = (0,react.useState)(formInitialValues), submitted = ref6[0], setSubmitted = ref6[1];
    var handleSubmit = function(values, param) {
        var setSubmitting = param.setSubmitting;
        setSubmitting(true);
        if (plans === "details") {
            axios/* default.post */.Z.post("reservation/payment-intent", {
                params: values
            }).catch(function(err) {
                return console.error(err);
            });
            //stripe verification if previous is valid
            //if everything checks, set Plans (thank you form)
            setPlans("payment");
            setSubmitted((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, submitted), {
                email: values.email,
                firstName: values.firstName,
                lastName: values.lastName
            }));
        }
        if (plans === "thankYou") {
            axios/* default.post */.Z.post("reservation/questions", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, values), {
                coupon: coupon,
                bonuses: bonuses,
                total: total,
                freeNights: numberOfFreeNights,
                freeNightlyRate: freeNightsCost,
                initialPrice: freeNightsOldPrice,
                reservationId: reservationId
            })).then(function() {
                setPlans("finish");
            }).catch(function(err) {
                return console.error(err);
            });
        }
        setSubmitted.apply(void 0, (0,_to_consumable_array/* default */.Z)(formInitialValues).concat([
            values
        ]));
        setSubmitting(false);
    };
    if (plans !== "finish") {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Columns/* default */.Z, {
            variant: [
                isThankYou && "no-gutter"
            ],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* default */.Z, {
                    variant: [
                        isThankYou && "no-padding"
                    ],
                    spans: isThankYou || isMobile ? 12 : 7,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                        onSubmit: handleSubmit,
                        enableReinitialize: true,
                        validationSchema: ReservationSchema,
                        initialValues: formInitialValues,
                        children: function(param) {
                            var values = param.values, setFieldValue = param.setFieldValue, errors = param.errors, touched = param.touched;
                            (0,react.useEffect)(function() {
                                setFieldValue("agreement", agreement);
                            }, [
                                agreement
                            ]);
                            (0,react.useEffect)(function() {
                                setFieldValue("total", updatedPrice.finalCost);
                            }, [
                                updatedPrice
                            ]);
                            if (plans === "details") {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
                                    className: (styles_module_default()).form,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_step_contact, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: (styles_module_default()).form__title,
                                            children: translations.contactDetails[router.locale]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomField/* default */.Z, {
                                                    variant: [
                                                        "hidden"
                                                    ],
                                                    readOnly: true,
                                                    name: "id",
                                                    value: propertyId
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomField/* default */.Z, {
                                                    variant: [
                                                        "hidden"
                                                    ],
                                                    readOnly: true,
                                                    name: "startDate",
                                                    value: startDate
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomField/* default */.Z, {
                                                    variant: [
                                                        "hidden"
                                                    ],
                                                    readOnly: true,
                                                    name: "endDate",
                                                    value: endDate
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomField/* default */.Z, {
                                                    variant: [
                                                        "hidden"
                                                    ],
                                                    readOnly: true,
                                                    name: "bedrooms",
                                                    value: bedrooms
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomField/* default */.Z, {
                                                    variant: [
                                                        "hidden"
                                                    ],
                                                    readOnly: true,
                                                    name: "total",
                                                    value: Number(total)
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomField/* default */.Z, {
                                                    variant: [
                                                        "full-width"
                                                    ],
                                                    required: true,
                                                    maxLength: 20,
                                                    name: "firstName",
                                                    placeholder: translations.form.fields.firstName[router.locale],
                                                    className: (styles_module_default()).form__inputs,
                                                    onChange: function(e) {
                                                        setFieldValue("firstName", e.target.value.replace(/[0-9]/g, ""));
                                                    },
                                                    error: errors.firstName && (touched === null || touched === void 0 ? void 0 : touched.firstName)
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomField/* default */.Z, {
                                                    variant: [
                                                        "full-width"
                                                    ],
                                                    maxLength: 20,
                                                    required: true,
                                                    name: translations.form.fields.lastName[router.locale],
                                                    placeholder: translations.form.fields.lastName[router.locale],
                                                    className: (styles_module_default()).form__inputs,
                                                    onChange: function(e) {
                                                        setFieldValue("lastName", e.target.value.replace(/[0-9]/g, ""));
                                                    },
                                                    error: errors.lastName && (touched === null || touched === void 0 ? void 0 : touched.lastName)
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomField/* default */.Z, {
                                                    variant: [
                                                        "full-width"
                                                    ],
                                                    maxLength: 254,
                                                    name: "email",
                                                    required: true,
                                                    placeholder: translations.form.fields.email[router.locale],
                                                    type: "email",
                                                    className: (styles_module_default()).form__inputs,
                                                    error: errors.email && touched.email,
                                                    valid: values.email && !errors.email && touched.email
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                                                    variant: [
                                                        "agreement"
                                                    ],
                                                    name: "agreement",
                                                    checkbox: true,
                                                    checked: agreement,
                                                    onChange: function() {
                                                        return setAgreement(!agreement);
                                                    },
                                                    label: translations.form.agreement[router.locale]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                                            disabled: values.email === null || values.firstName === null || values.lastName === null,
                                            children: translations.form.fields.continue[router.locale]
                                        })
                                    ]
                                });
                            }
                            if (plans === "payment") {
                                var ref, ref1;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (styles_module_default()).form,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_step_payment, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: (styles_module_default()).form__title,
                                            children: translations.stripe.paymentDetails[router.locale]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(single_property_StripeComponent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                            translations: translations.stripe,
                                            setReservationId: setReservationId,
                                            setPlans: setPlans,
                                            setSkip: setSkip,
                                            updatedPrice: updatedPrice,
                                            coupon: coupon,
                                            freeNights: numberOfFreeNights,
                                            freeNightlyRate: freeNightsCost,
                                            initialPrice: freeNightsOldPrice
                                        }, submitted), {
                                            propertyId: (ref = detailsProps.property) === null || ref === void 0 ? void 0 : ref.resource_id,
                                            listingId: (ref1 = detailsProps.property) === null || ref1 === void 0 ? void 0 : ref1.id,
                                            total: updatedPrice ? Number(updatedPrice.finalCost) : Number(total)
                                        }))
                                    ]
                                });
                            }
                            if (isThankYou) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalContent_ThankYou, {
                                    translations: translations.thankYou,
                                    setFieldValue: setFieldValue
                                });
                            }
                        }
                    })
                }),
                !isThankYou && /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* default */.Z, {
                    spans: isMobile ? 12 : 5,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalContent_Details, (0,_object_spread/* default */.Z)({}, detailsProps))
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (styles_module_default()).finish,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (styles_module_default()).finish__title,
                children: skip ? translations.skip.title1[router.locale] : translations.skip.title2[router.locale]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (styles_module_default()).finish__subtitle,
                children: skip ? translations.skip.subtitle1[router.locale] : translations.skip.subtitle2[router.locale]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).finish__separator
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: (styles_module_default()).finish__description,
                children: [
                    translations === null || translations === void 0 ? void 0 : translations.skip.questions[router.locale],
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        rel: "nofollow",
                        href: "mailto:reservations@stmartinsothebysrealty.com",
                        children: "reservations@stmartinsothebysrealty.com"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                href: "/guest-experience",
                onClick: function() {
                    handleCloseModal();
                },
                arrow: false,
                variant: [
                    "color-accent"
                ],
                children: translations.skip.button[router.locale]
            })
        ]
    });
};
/* harmony default export */ var components_ModalContent = (ModalContent);


/***/ }),

/***/ 49727:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"field":"styles_field__h8_cg","field__label":"styles_field__label__ezuBG","field__wrapper":"styles_field__wrapper__hfZnh","field__content":"styles_field__content__rCr6i","field__content--is-active":"styles_field__content--is-active__6eGg0","field__footer":"styles_field__footer__UhQVV","field--right":"styles_field--right__7SxmX","field--top":"styles_field--top__WGOsK","field--content-simple":"styles_field--content-simple__Lrcd4","field--content-xs":"styles_field--content-xs__K86T2","field--footer-close":"styles_field--footer-close__BwEfB"};

/***/ }),

/***/ 42998:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"separator":"styles_separator__LP5R2","separator--vertical":"styles_separator--vertical__XAMVo","separator--center":"styles_separator--center__qDfXg","separator--full-width":"styles_separator--full-width__WOn53"};

/***/ }),

/***/ 78897:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spinner":"styles_spinner__sgQJp","loading":"styles_loading__2EGmZ","spinner--white":"styles_spinner--white__wuXJ0","spinner--darker":"styles_spinner--darker__oN4CN","spinner--black":"styles_spinner--black__LbiGp"};

/***/ }),

/***/ 39361:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"payment_form":"styles_payment_form__RrRnt","label":"styles_label__XbsoL","payment_message":"styles_payment_message__wqUmb","note":"styles_note__yI_e3","skip":"styles_skip__VdAft","payment_error_message":"styles_payment_error_message__j93b3","button_submit":"styles_button_submit__vaz2F","spinner":"styles_spinner__yrIe_","loading":"styles_loading__4GY_C"};

/***/ }),

/***/ 61825:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"details":"styles_details__eVRu0","details__title":"styles_details__title__hYCEQ","details__bedroom":"styles_details__bedroom__Q_IaN","details__note":"styles_details__note__gRYJx","details__row":"styles_details__row__HEsxO","details__row--merged":"styles_details__row--merged__er5HC","details__slider":"styles_details__slider__PjMbK","form":"styles_form__iITWn","form__field":"styles_form__field__Hv58G","form__error":"styles_form__error__FVtPU","form__button":"styles_form__button__K8trt"};

/***/ }),

/***/ 37691:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__keywt","form__intro":"styles_form__intro__Jflwe","form__title":"styles_form__title__8_32V","form__additional":"styles_form__additional__JYKiQ","form__submit":"styles_form__submit__9UDLh","form__label":"styles_form__label__vnNIH","form__inputs":"styles_form__inputs__FdxZe","form--thanks":"styles_form--thanks__Bjn6l","thanks":"styles_thanks__E3Ir3","finish":"styles_finish__I4ew_","finish__title":"styles_finish__title__v_OsY","finish__subtitle":"styles_finish__subtitle__OrHxd","finish__separator":"styles_finish__separator__0WhjU","finish__description":"styles_finish__description__0m8oj"};

/***/ })

}]);